<div class="content-column">
  <dx-text-box
    #urlTextBoxRef
    [width]="'100%'"
    valueChangeEvent="input"
    (onValueChanged)="urlSig.set($event.value)"
    [label]="'Url'"
    [labelMode]="'floating'"
    [showClearButton]="true"
    class="upload-from-disk-tab__text-input"
    [buttons]="[
      {
        name: 'loading',
        location: 'after',
        options: {
          template: 'loadingButtonTemplate',
          elementAttr: {
            class: 'inline-editor-control',
          },
          type: 'default',
          stylingMode: 'text',
          hint: 'Loading',
          disabled: !isLoadingSig(),
          visible: isLoadingSig(),
        },
      },
      {
        name: 'success',
        location: 'after',
        options: {
          template: 'successButtonTemplate',
          stylingMode: 'text',
          type: 'success',
          hint: 'Success',
          visible: isSuccessSig() && !isLoadingSig(),
        },
      },
      {
        name: 'error',
        location: 'after',
        options: {
          template: 'errorButtonTemplate',
          stylingMode: 'text',
          type: 'danger',
          hint: '',
          visible: !isValidSig() && !isLoadingSig(),
        },
      },
      {
        name: 'clear',
        location: 'after',
      },
    ]"
  >
    <div *dxTemplate="let item of 'loadingButtonTemplate'" class="editor-progress-indicator">
      <ng-container *ngIf="isLoadingSig(); then loadIndicatorTmp"></ng-container>
    </div>

    <div *dxTemplate="let item of 'successButtonTemplate'">
      <i *ngIf="isSuccessSig() && !isLoadingSig()" class="dx-icon-check success-icon"></i>
    </div>

    <div *dxTemplate="let item of 'errorButtonTemplate'">
      <i id="error-icon" *ngIf="!isValidSig() && !isLoadingSig()" class="dx-icon-agi-exclamation-circle error-icon"></i>
      <dx-tooltip
        target="#error-icon"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
        [wrapperAttr]="{class: 'error-tooltip'}"
      >
        <p *dxTemplate="let data = data; of: 'content'">
          Unable to load the image from this URL.
        </p>
      </dx-tooltip>
    </div>

    <ng-template #loadIndicatorTmp>
      <dx-load-indicator
        class="editor-progress-indicator__indicator"
        [visible]="true"
        height="18"
        width="18"
      ></dx-load-indicator>
    </ng-template>
  </dx-text-box>

  <ng-content></ng-content>
</div>

<div class="preview-column">
  <ag-shr-image-preview
    [src]="imagePreviewUrl"
    [placeholder]="'Insert the Image Url'"
    [isValid]="_isImageValid$ | async"
    (isValidChange)="handleIsImageValid($event)"
  ></ag-shr-image-preview>
</div>
